<script>
/**
 * ユーザ属性取得用ミックスイン
 * 1.ユーザ属性取得成功時
 * ・「this.miiafwCognitolibs_updateAttributes()」をコールする。(引数は取得したユーザ属性)
 * 2.ユーザ属性取得失敗時、プロファイル表示機能を使用しない場合
 * ・「this.miiafwCognitolibs_updateAttributes()」をコールする。(引数は空のオブジェクト({}))
 */
import MiiaFwCognitoMixin from '@/components/miiafw/mixin/MiiaFwCognitoMixin.vue'

export default {
  name: 'MiiaFwUserAttributesMixin',
  mixins: [MiiaFwCognitoMixin],
  methods: {
    // ユーザ属性取得
    miiafwUserAttributes_getAttributes () {
      return new Promise((resolve, reject) => {
        const userId = this.miiafwCognitolibs_getUserIdToStorage()
        if (userId === '') {
          reject({ message: 'ユーザIDを取得できませんでした。' })
        }
        const tokens = this.miiafwCognitolibs_getTokens()
        if (tokens === null || !Object.prototype.hasOwnProperty.call(tokens, 'provider')) {
          reject({ message: 'サインアウト中です。' })
        }
        if (tokens.provider.toLowerCase() === 'cognito') {
          this.miiafwCognitolibs_invokeApiGwFunc(
            this.$authEndpoint,
            // Lambda関数をコールするためのWebAPIのサブディレクトリ
            '/integrated-auth-user-m-dao',
            // Lambda関数に渡す引数
            { function: 'get', params: { user_id: userId, system: this.$sysId } },
            // Lambda関数実行前の前処理のコールバック
            () => {},
            // 成功時のコールバック
            (data) => {
              this.miiafwCognitolibs_updateAttributes(data.result)
              resolve(data.result)
            },
            // 例外受信時のコールバック(引数: エラーメッセージ)
            (message) => {
              this.miiafwCognitolibs_updateAttributes({})
              reject({ message: message })
            },
            // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
            () => {
              this.miiafwCognitolibs_updateAttributes({})
              reject({ message: 'API実行に失敗しました。(原因: アクセス回線障害など)' })
            },
            // 処理完了後に実行するコールバック
            () => {}
          )
        } else if (tokens.provider.toLowerCase() === 'google') {
          const authInstance = gapi.auth2.getAuthInstance() // eslint-disable-line
          authInstance.then(() => { // onInit
            const isSignedIn = authInstance.isSignedIn.get()
            if (isSignedIn) {
              const googleUser = authInstance.currentUser.get()
              const profile = googleUser.getBasicProfile()
              const userAttr = {
                user_id: profile.getId(),
                user_name: profile.getName(),
                email: profile.getEmail(),
                image_url: profile.getImageUrl()
              }
              this.miiafwCognitolibs_updateAttributes(userAttr)
              resolve(userAttr)
            } else {
              this.miiafwCognitolibs_updateAttributes({})
              reject({ message: 'サインアウト中です。' })
            }
          }, (error) => { // onError
            this.miiafwCognitolibs_updateAttributes({})
            reject({ message: error.error })
          })
        } else if (tokens.provider.toLowerCase() === 'facebook') {
          window.FB.api(
            // '/' + response.authResponse.userID + '?fields=id,name,gender,email,picture,work,birthday,hometown' + '&access_token=' + response.authResponse.accessToken,
            '/' + userId,
            { fields: 'id,name,gender,email,picture,work,birthday,hometown', access_token: tokens.access_token },
            (resAttr) => {
              if (!resAttr || resAttr.error) {
                this.miiafwCognitolibs_updateAttributes({})
                reject({ message: resAttr.error })
              } else {
                const userAttr = {
                  user_id: resAttr.id,
                  user_name: resAttr.name,
                  email: resAttr.email,
                  image_url: resAttr.picture.data.url
                }
                // console.log('gender', resAttr.gender)
                // console.log('work', resAttr.work)
                // console.log('birthday', resAttr.birthday)
                // console.log('hometown', resAttr.hometown)
                this.miiafwCognitolibs_updateAttributes(userAttr)
                resolve(userAttr)
              }
            }
          )
        } else if (tokens.provider.toLowerCase() === 'twitter') {
          // TODO(属性情報取得&登録)
          this.miiafwCognitolibs_updateAttributes({ user_name: 'twitter' })
          resolve({ user_name: 'twitter' })
        } else {
          reject({ message: '対応していないIDプロバイダが設定されました。' })
        }
      })
    }
  }
}
</script>
